module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SiteSection', {
    attrs: {
      "sectionId": "section-qa",
      "sectionNo": "5",
      "label": "QA 專區",
      "title": "Question? Looks Here!"
    }
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('Question')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ec3e2364"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionQuestion.vue
// module id = 688
// module chunks = 0